var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@templates/components/molecules/favoriteButton.html.njk"] = require( "@templates/components/molecules/favoriteButton.html.njk" );
dependencies["@templates/components/molecules/house-feature-list.html.njk"] = require( "@templates/components/molecules/house-feature-list.html.njk" );
dependencies["@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk"] = require( "@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk" );
dependencies["@naturehouse/design-system/components/molecules/carousel/simple-carousel/SimpleCarousel.macro.njk"] = require( "@naturehouse/design-system/components/molecules/carousel/simple-carousel/SimpleCarousel.macro.njk" );
dependencies["@templates/components/organisms/card-house-last-minute.html.njk"] = require( "@templates/components/organisms/card-house-last-minute.html.njk" );
dependencies["@naturehouse/design-system/components/atoms/rating/Rating.macro.njk"] = require( "@naturehouse/design-system/components/atoms/rating/Rating.macro.njk" );
dependencies["@templates/components/organisms/card-house-price.html.njk"] = require( "@templates/components/organisms/card-house-price.html.njk" );




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/organisms/card-house.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@templates/components/molecules/favoriteButton.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("favoriteButton", t_1);
output += "\n";
env.getTemplate("@templates/components/molecules/house-feature-list.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("houseFeatureList", t_4);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("toolTip", t_7);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/molecules/carousel/simple-carousel/SimpleCarousel.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
context.setVariable("imageCarousel", t_10);
output += "\n\n";
if(!env.getTest("defined").call(context, runtime.contextOrFrameLookup(context, frame, "compact")) === true) {
output += "\n    ";
var t_13;
t_13 = false;
frame.set("compact", t_13, true);
if(frame.topLevel) {
context.setVariable("compact", t_13);
}
if(frame.topLevel) {
context.addExport("compact", t_13);
}
output += "\n";
;
}
output += "\n\n";
if(!env.getTest("defined").call(context, runtime.contextOrFrameLookup(context, frame, "shouldCache")) === true) {
output += "\n    ";
var t_14;
t_14 = false;
frame.set("shouldCache", t_14, true);
if(frame.topLevel) {
context.setVariable("shouldCache", t_14);
}
if(frame.topLevel) {
context.addExport("shouldCache", t_14);
}
output += "\n";
;
}
output += "\n\n";
var t_15;
t_15 = env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"images")) === true && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"images")) > 1;
frame.set("showCarousel", t_15, true);
if(frame.topLevel) {
context.setVariable("showCarousel", t_15);
}
if(frame.topLevel) {
context.addExport("showCarousel", t_15);
}
output += "\n";
var t_16;
t_16 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id");
frame.set("houseId", t_16, true);
if(frame.topLevel) {
context.setVariable("houseId", t_16);
}
if(frame.topLevel) {
context.addExport("houseId", t_16);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "showCarousel")) {
output += "\n    ";
var t_17;
t_17 = [];
frame.set("slides", t_17, true);
if(frame.topLevel) {
context.setVariable("slides", t_17);
}
if(frame.topLevel) {
context.addExport("slides", t_17);
}
output += "\n    ";
frame = frame.push();
var t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"images");
if(t_20) {t_20 = runtime.fromIterator(t_20);
var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("image", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
output += "\n        ";
var t_22;
t_22 = [{"width": 295,"height": 221},{"width": 335,"height": 251},{"width": 390,"height": 293},{"width": 430,"height": 322},{"width": 560,"height": 420},{"width": 590,"height": 442}];
frame.set("sizes", t_22, true);
if(frame.topLevel) {
context.setVariable("sizes", t_22);
}
if(frame.topLevel) {
context.addExport("sizes", t_22);
}
output += "\n\n        ";
var t_23;
t_23 = "";
frame.set("srcset", t_23, true);
if(frame.topLevel) {
context.setVariable("srcset", t_23);
}
if(frame.topLevel) {
context.addExport("srcset", t_23);
}
output += "\n        ";
frame = frame.push();
var t_26 = runtime.contextOrFrameLookup(context, frame, "sizes");
if(t_26) {t_26 = runtime.fromIterator(t_26);
var t_25 = t_26.length;
for(var t_24=0; t_24 < t_26.length; t_24++) {
var t_27 = t_26[t_24];
frame.set("size", t_27);
frame.set("loop.index", t_24 + 1);
frame.set("loop.index0", t_24);
frame.set("loop.revindex", t_25 - t_24);
frame.set("loop.revindex0", t_25 - t_24 - 1);
frame.set("loop.first", t_24 === 0);
frame.set("loop.last", t_24 === t_25 - 1);
frame.set("loop.length", t_25);
output += "\n            ";
var t_28;
t_28 = runtime.contextOrFrameLookup(context, frame, "srcset") + "" + t_21 + "" + ",fit=cover,width=" + "" + runtime.memberLookup((t_27),"width") + "" + ",height=" + "" + runtime.memberLookup((t_27),"height") + "" + " " + "" + runtime.memberLookup((t_27),"width") + "" + "w,";
frame.set("srcset", t_28, true);
if(frame.topLevel) {
context.setVariable("srcset", t_28);
}
if(frame.topLevel) {
context.addExport("srcset", t_28);
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n        ";
var t_29;
t_29 = env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "srcset"),",");
frame.set("srcset", t_29, true);
if(frame.topLevel) {
context.setVariable("srcset", t_29);
}
if(frame.topLevel) {
context.addExport("srcset", t_29);
}
output += "\n\n        ";
var t_30;
t_30 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "slides"),[{"src": t_21 + "" + ",fit=cover,width=28,height=21","srcset": runtime.contextOrFrameLookup(context, frame, "srcset"),"sizes": "\n                (max-width: 767px) calc(100vw - 2.5rem),\n                (max-width: 1023px) calc(33vw - 2.5rem),\n                (max-width: 1279px) calc(21.67vw - 2.5rem),\n                295px","alt": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"),"loading": "lazy"}]);
frame.set("slides", t_30, true);
if(frame.topLevel) {
context.setVariable("slides", t_30);
}
if(frame.topLevel) {
context.addExport("slides", t_30);
}
output += "\n    ";
;
}
}
frame = frame.pop();
output += "\n";
;
}
output += "\n\n<article class=\"card card--horizontal card--house-search\" data-house-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"), env.opts.autoescape);
output += "\" data-distance=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"distance"), env.opts.autoescape);
output += "\">\n    <header class=\"card__header\">\n        <a class=\"card--anchor\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\" target=\"_blank\" data-role=\"open-house-detail\">\n            <div class=\"card__image-container\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showCarousel")) {
output += "\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 53, colno = 43, runtime.callWrap(runtime.memberLookup((t_10),"render"), "imageCarousel[\"render\"]", context, [{"slides": runtime.contextOrFrameLookup(context, frame, "slides"),"loading": env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "loading"),"eager")}]))), env.opts.autoescape);
output += "\n                ";
;
}
else {
output += "\n                    <img\n                        src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=280,height=210", env.opts.autoescape);
output += "\"\n                        srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=295,height=221", env.opts.autoescape);
output += " 295w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=335,height=251", env.opts.autoescape);
output += " 335w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=390,height=293", env.opts.autoescape);
output += " 390w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=430,height=322", env.opts.autoescape);
output += " 430w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=560,height=420", env.opts.autoescape);
output += " 560w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=590,height=442", env.opts.autoescape);
output += " 590w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=670,height=502", env.opts.autoescape);
output += " 670w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=780,height=585", env.opts.autoescape);
output += " 780w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=860,height=644", env.opts.autoescape);
output += " 860w,\n                                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"imageUrl") + "" + ",fit=cover,width=1170,height=877", env.opts.autoescape);
output += " 1170w\"\n                        sizes=\"(max-width: 767px) calc(100vw - 2.5rem),\n                            (max-width: 1023px) calc(33vw - 2.5rem),\n                            (max-width: 1279px) calc(21.67vw - 2.5rem),\n                            295px\"\n                        alt=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"), env.opts.autoescape);
output += "\"\n                        class=\"card__image\"\n                        loading=\"lazy\"\n                        width=\"280\"\n                        height=\"210\"\n                    >\n                ";
;
}
output += "\n            </div>\n        </a>\n\n        ";
output += runtime.suppressValue((lineno = 84, colno = 32, runtime.callWrap(runtime.memberLookup((t_1),"render"), "favoriteButton[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "house"),env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "is_favorite"),false)])), env.opts.autoescape);
output += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "shouldCache") == true) {
output += "HOUSE_LAST_MINUTE_PLACEHOLDER";
;
}
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "shouldCache") == false) {
output += "\n            ";
var t_31;
t_31 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("has_lastminute_price", t_31, true);
if(frame.topLevel) {
context.setVariable("has_lastminute_price", t_31);
}
if(frame.topLevel) {
context.addExport("has_lastminute_price", t_31);
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "has_lastminute_price")) {
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("@templates/components/organisms/card-house-last-minute.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
callback(null,t_32);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_35,t_34) {
if(t_35) { cb(t_35); return; }
callback(null,t_34);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n            ";
});
}
output += "\n        ";
;
}
output += "\n    </header>\n\n    <div class=\"card__content\">\n        <header class=\"card__content__header\">\n            <div class=\"card__content__header-title\">\n                <div>\n                    <span class=\"card__title\">\n                        <a data-role=\"open-house-detail\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\" target=\"_blank\">\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"title"), env.opts.autoescape);
output += "\n                        </a>\n                    </span>\n                    <span class=\"card__subtitle\" data-testid=\"house-location\">\n\n                        ";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"locationTitle")) === true) {
output += "\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"locationTitle"), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    </span>\n                </div>\n\n                ";
if(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"natureRating"),0) > 0 && env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "compact"),false) == false) {
output += "\n                    <div class=\"nh-rating-container\">\n                        ";
env.getTemplate("@naturehouse/design-system/components/atoms/rating/Rating.macro.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_37,t_36) {
if(t_37) { cb(t_37); return; }
t_36.getExported(function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
context.setVariable("ratingTemplate", t_36);
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 119, colno = 48, runtime.callWrap(runtime.memberLookup((t_36),"render"), "ratingTemplate[\"render\"]", context, [{"variant": "nature","value": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"natureRating")}]))), env.opts.autoescape);
output += "\n                    </div>\n                ";
})});
}
output += "\n            </div>\n\n            ";
output += runtime.suppressValue((lineno = 127, colno = 38, runtime.callWrap(runtime.memberLookup((t_4),"render"), "houseFeatureList[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "house"),runtime.contextOrFrameLookup(context, frame, "translations")])), env.opts.autoescape);
output += "\n        </header>\n\n        <footer class=\"card__content__footer\">\n            <div class=\"card__content__footer__pricing\" data-section=\"pricing\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "shouldCache") == true) {
output += "HOUSE_PRICE_PLACEHOLDER";
;
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "shouldCache") == false) {
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("@templates/components/organisms/card-house-price.html.njk", false, "templates/components/organisms/card-house.html.njk", false, function(t_40,t_39) {
if(t_40) { cb(t_40); return; }
callback(null,t_39);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_42,t_41) {
if(t_42) { cb(t_42); return; }
callback(null,t_41);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n                ";
});
}
output += "\n            </div>\n        </footer>\n    </div>\n</article>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/organisms/card-house.html.njk"] , dependencies)